export enum DragonTigerCardPosition {
    DragonCard = 0,
    TigerCard = 1
}

export enum DragonTigerOutcome {
    DragonWin = 0,
    TigerWin = 1,
    Tie = 2
}

export enum DragonTigerSidePosition {
    Tiger = 'tiger',
    Dragon = 'dragon'
}

export interface DragonTigerHandValues {
    dragonHandValue: number;
    tigerHandValue: number;
}
